import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import axiosInstance from '../../axiosConfig';

const fetchMpCatalogueAssociations = async (params) => {
  const response = await axiosInstance.get('/mp_catalogues/associations/', {
    params,
  });
  return response.data;
};

export const useGetMpCatalogueAssociations = (params = {}, options = {}) => {
  const queryParams = useMemo(() => {
    const out = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') out[k] = v;
    });
    return out;
  }, [params]);

  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['mpCatalogueAssociations', queryParams],
    queryFn: () => fetchMpCatalogueAssociations(queryParams),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const mpCatalogueAssociations = data?.results;
  const count = data?.count;
  const next = data?.next;
  const previous = data?.previous;

  return {
    mpCatalogueAssociations,
    count,
    next,
    previous,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
